import { render, staticRenderFns } from "./MicrosoftAuthorization.vue?vue&type=template&id=598bc76f&scoped=true"
import script from "./MicrosoftAuthorization.vue?vue&type=script&lang=js"
export * from "./MicrosoftAuthorization.vue?vue&type=script&lang=js"
import style0 from "./MicrosoftAuthorization.vue?vue&type=style&index=0&id=598bc76f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598bc76f",
  null
  
)

export default component.exports